import React, { useEffect } from "react";
import './Privacy_policy.css';
import Common_title from '../common-components/common-title/Common_title';

const Privacy_policy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className='Privacy_policy'>
      <div className='container'>
        <Common_title subtitle="Privacy Policy for GeeCart" />

        <div className='white_card'>

          <p className='point_title'>Effective Date: 20 August 2026</p>
          <p className='descn_text'>
            At GeeCart, we are deeply committed to protecting your privacy and ensuring a safe, convenient, and secure shopping experience.
            This commitment applies whether you're browsing our website, using our mobile app, making an online purchase for delivery or pickup, or visiting our physical store locations.
            This Privacy Policy explains how GeeCart (“we,” “us,” or “our,” acting as the <strong>“Data Fiduciary”</strong> under the Digital Personal Data Protection Act, 2023) collects, uses, discloses, and protects your personal information when you interact with our services.
          </p>

          <p className='descn_text'>
            By accessing or using any part of GeeCart's website or mobile application, you, as the <strong>“Data Principal,”</strong> agree to the collection and use of your personal data in accordance with this policy and the Digital Personal Data Protection Act, 2023.
          </p>

          <br />

          <p className='point_title'>1. Information We Collect</p>
          <p className='descn_text'>
            We collect various types of information to provide, improve, and personalize your shopping experience.
          </p>

          <p className='point_title'>A. Information You Provide Directly to Us:</p>
          <ul className='descn_text'>
            <li><strong>Account & Registration Information:</strong> When you create an account or sign up for our loyalty program ("Prime Rewards"), we collect your name, email address, phone number, password, and optional date of birth.</li>
            <li><strong>Order & Transaction Information:</strong> Delivery address, billing address, payment details (processed securely via third-party payment gateways), order history, and delivery preferences.</li>
            <li><strong>Customer Service Interactions:</strong> Transcripts, email correspondence, or notes from your communications with our customer support team.</li>
            <li><strong>User Content:</strong> Product reviews, ratings, testimonials, or feedback submitted on our platform.</li>
          </ul>

          <br />

          <p className='point_title'>B. Information Collected Automatically:</p>
          <ul className='descn_text'>
            <li><strong>Usage Data:</strong> Pages viewed, products searched or browsed (watches, clothing, footwear, electronics), navigation paths, and time spent on features.</li>
            <li><strong>Device Information:</strong> IP address, operating system, browser type, unique device identifiers, and mobile network details.</li>
            <li><strong>Location Data:</strong> With your permission, precise or approximate location information to optimize delivery options and showcase nearby offers.</li>
            <li><strong>Cookies & Tracking:</strong> Data collected via cookies and pixels to keep you logged in, save cart contents, and deliver tailored promotions.</li>
          </ul>

          <br />

          <p className='point_title'>2. How We Use Your Information</p>
          <p className='descn_text'>
            We process your personal data for clear, lawful e-commerce operations:
          </p>
          <ul className='descn_text'>
            <li>Fulfilling and dispatching orders, managing payments, and processing returns or refunds.</li>
            <li>Managing your account and "Prime Rewards" points.</li>
            <li>Recommending products, discounts, and flash sales based on your shopping preferences.</li>
            <li>Preventing fraudulent activities, unauthorized transactions, and maintaining network security.</li>
            <li>Complying with applicable legal obligations under Indian law.</li>
          </ul>

          <br />

          <p className='point_title'>3. How We Share Your Information</p>
          <p className='descn_text'>
            We do not sell your personal data. We only share information with trusted third parties under strict confidentiality standards:
          </p>
          <ul className='descn_text'>
            <li><strong>Logistics & Delivery Partners:</strong> Courier services requiring your address and contact details to deliver purchases.</li>
            <li><strong>Payment Gateways:</strong> Certified PCI-DSS compliant processors handling secure card and UPI payments.</li>
            <li><strong>Service Providers:</strong> Cloud hosting, SMS/email gateway providers, and customer analytics tools.</li>
            <li><strong>Legal Compliance:</strong> When required by court order, law enforcement request, or applicable government regulations.</li>
          </ul>

          <br />

          <p className='point_title'>4. Data Security</p>
          <p className='descn_text'>
            We implement robust technical and organizational security measures to safeguard your personal data in compliance with the Digital Personal Data Protection Act, 2023:
          </p>
          <ul className='descn_text'>
            <li>SSL/TLS encryption for all transmitted online data and payment processing.</li>
            <li>Full compliance with Payment Card Industry Data Security Standards (PCI DSS).</li>
            <li>Restricted employee access and periodic security vulnerability audits.</li>
          </ul>

          <br />

          <p className='point_title'>5. Data Retention</p>
          <p className='descn_text'>
            We retain your information for as long as your account remains active or as needed to provide services, resolve disputes, and comply with tax and legal accounting requirements under Indian law. Unneeded data is securely deleted or anonymized.
          </p>

          <br />

          <p className='point_title'>6. Your Privacy Rights</p>
          <p className='descn_text'>
            Under the Digital Personal Data Protection Act, 2023, you have the following rights as a Data Principal:
          </p>
          <ul className='descn_text'>
            <li><strong>Right to Access:</strong> Summary of your processed personal data and history.</li>
            <li><strong>Right to Correction & Erasure:</strong> Request updates to inaccurate details or request account deletion.</li>
            <li><strong>Right to Withdraw Consent:</strong> Opt out of promotional emails or revoke permissions at any time.</li>
            <li><strong>Right to Nominate:</strong> Appoint an individual to exercise your rights in the event of incapacity.</li>
          </ul>

          <br />

          <p className='point_title'>7. Third-Party Links</p>
          <p className='descn_text'>
            Our platform may contain links to external sites or payment portals. We strongly advise reviewing their respective privacy policies as we hold no control over third-party practices.
          </p>

          <br />

          <p className='point_title'>8. Contact Us & Grievance Redressal</p>
          <p className='descn_text'>
            If you have questions or wish to exercise your privacy rights, please reach out to our designated <strong>Grievance Officer</strong>:
          </p>
          <p className='descn_text'>
            <strong>Grievance Officer:</strong> Girish Harchandani<br />
            <strong>Email:</strong> <a href="mailto:girishharchandani1313@gmail.com">girishharchandani1313@gmail.com</a><br />
            <strong>Phone / Support:</strong> +91 7020921927 (10:00 AM – 11:00 PM IST)<br />
            <strong>Postal Address:</strong><br />
            Bhaji Mandai, Siru Chouk, Gandhinagar, Karvir, Kolhapur - 416119
          </p>
          <p className='descn_text'>
            If your grievance is not resolved to your satisfaction, you retain the right to escalate your concern to the <strong>Data Protection Board of India</strong>.
          </p>

        </div>
      </div>
    </section>
  );
};

export default Privacy_policy;